import React from "react";
import Select from "../../../../form/Select";
import {optionsTemplate} from "../../../../../utils/formatters";

export default (propsTop) => {
    const componentProps = {...propsTop};
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    const sourceProps = props.getProps("source");
    return (
        <div className="row form-row">
            <div className="col-md-12">
                <Select
                    label="Raktár"
                    name="source"
                    component="store"
                    isClearable={props.user.hasPermission("change_inventory")}
                    objectValue={true}
                    labelKey="name"
                    storeType="remote"
                    optionsTemplate={optionsTemplate("location")}
                    {...sourceProps}
                    disabled={sourceProps.disabled || !props.user.hasPermission("change_inventory")}
                    value={props.getValue("source")}
                    saveChanges={props.setFieldValue}
                />
            </div>
        </div>
    );
}